var map = {
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./despiece/despiece.module": [
		"./src/app/despiece/despiece.module.ts",
		"despiece-despiece-module~orders-order-module~profile-profile-module~reports-reports-module~session-s~58a57e82",
		"common",
		"despiece-despiece-module"
	],
	"./orders/order.module": [
		"./src/app/orders/order.module.ts",
		"despiece-despiece-module~orders-order-module~profile-profile-module~reports-reports-module~session-s~58a57e82",
		"common",
		"orders-order-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"despiece-despiece-module~orders-order-module~profile-profile-module~reports-reports-module~session-s~58a57e82",
		"profile-profile-module~session-session-module~user-user-module",
		"common",
		"profile-profile-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"despiece-despiece-module~orders-order-module~profile-profile-module~reports-reports-module~session-s~58a57e82",
		"common",
		"reports-reports-module"
	],
	"./session/session.module": [
		"./src/app/session/session.module.ts",
		"despiece-despiece-module~orders-order-module~profile-profile-module~reports-reports-module~session-s~58a57e82",
		"profile-profile-module~session-session-module~user-user-module",
		"common",
		"session-session-module"
	],
	"./user/user.module": [
		"./src/app/user/user.module.ts",
		"despiece-despiece-module~orders-order-module~profile-profile-module~reports-reports-module~session-s~58a57e82",
		"profile-profile-module~session-session-module~user-user-module",
		"common",
		"user-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;